import type { IconData } from '@stacksjs/iconify-core'

export const sunset: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M36.373 28A13 13 0 0 0 37 24c0-7.18-5.82-13-13-13s-13 5.82-13 13c0 1.396.22 2.74.627 4M24 3v3m21 18h-3M6 24H3m8.272-12.727L9.151 9.15m27.577 2.123l2.121-2.122M3 45c1.89 0 3.78-.556 5.42-1.67a2.86 2.86 0 0 1 3.16 0A9.64 9.64 0 0 0 17 45c1.89 0 3.78-.556 5.42-1.67a2.86 2.86 0 0 1 3.16 0A9.64 9.64 0 0 0 31 45c1.89 0 3.78-.556 5.42-1.67a2.86 2.86 0 0 1 3.16 0A9.64 9.64 0 0 0 45 45M3 37c1.89 0 3.78-.556 5.42-1.67a2.86 2.86 0 0 1 3.16 0A9.64 9.64 0 0 0 17 37c1.89 0 3.78-.556 5.42-1.67a2.86 2.86 0 0 1 3.16 0A9.64 9.64 0 0 0 31 37c1.89 0 3.78-.556 5.42-1.67a2.86 2.86 0 0 1 3.16 0A9.64 9.64 0 0 0 45 37\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default sunset
